// REMOVE WITH KEYCLOAK_SSO_ENABLED — cleanup epic
import { Link as MuiLink, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';
// constants
import { SUPPORT_EMAIL } from '../../constants/sso';
// sections
import SsoSignInButton from './login/SsoSignInButton';

// ----------------------------------------------------------------------

const IconWrap = styled('div')(({ theme }) => ({
  width: 56,
  height: 56,
  borderRadius: '50%',
  backgroundColor: theme.palette.info.lighter ?? '#CAFDF5',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

// ----------------------------------------------------------------------

export default function LinkedUserInterstitialPage() {
  return (
    <Stack spacing={3} alignItems="center" sx={{ textAlign: 'center', py: 2 }}>
      <IconWrap>
        <InfoOutlinedIcon sx={{ color: 'info.dark', fontSize: 28 }} aria-hidden />
      </IconWrap>

      <Typography variant="h5" component="h1">
        Your company has moved to
        <br />
        WorkWise sign-in
      </Typography>

      <Typography color="text.secondary">
        To continue, please sign in with WorkWise.
      </Typography>

      <SsoSignInButton />

      <Typography variant="body2" color="text.secondary">
        Need help?{' '}
        <MuiLink href={`mailto:${SUPPORT_EMAIL}`} underline="hover">
          Contact support
        </MuiLink>
      </Typography>
    </Stack>
  );
}
